/**
 * Trạng thái đồng bộ khi có mạng
 */
export default {
  Success: 1,
  Fail: 0,
};
